import { useTranslation } from 'react-i18next';
import { LegalLayout } from './LegalLayout';
import { LEGAL } from '../../config/legal';

/**
 * Impressum / legal notice (§5 DDG).
 *
 * Renders only the details that are actually filled in `config/legal.ts` — company
 * data is never guessed here. Until the address, register entry and managing
 * director are supplied the notice is incomplete; see `hasImpressumDetails`.
 */
export default function Impressum() {
  const { t } = useTranslation();

  const rows: Array<{ label: string; value: string; href?: string }> = [
    { label: t('impressum.operator'), value: LEGAL.entityName },
    { label: t('impressum.address'), value: LEGAL.address },
    { label: t('impressum.managingDirector'), value: LEGAL.managingDirector },
    { label: t('impressum.registerCourt'), value: LEGAL.registerCourt },
    { label: t('impressum.registerNumber'), value: LEGAL.registerNumber },
    { label: t('impressum.vatId'), value: LEGAL.vatId },
    { label: t('impressum.email'), value: LEGAL.supportEmail, href: `mailto:${LEGAL.supportEmail}` },
    { label: t('impressum.privacyEmail'), value: LEGAL.privacyEmail, href: `mailto:${LEGAL.privacyEmail}` },
  ].filter((row) => row.value);

  return (
    <LegalLayout title={t('impressum.title')} updated={t('impressum.subtitle')}>
      <section>
        <dl className="impressum-list">
          {rows.map((row) => (
            <div key={row.label} className="impressum-row">
              <dt>{row.label}</dt>
              <dd>{row.href ? <a href={row.href}>{row.value}</a> : row.value}</dd>
            </div>
          ))}
        </dl>
      </section>
      <style>{`
        .impressum-list { margin: 0; }
        .impressum-row { margin: 0 0 20px; }
        .impressum-row dt { font-weight: 600; color: #555; font-size: 14px; }
        .impressum-row dd { margin: 4px 0 0; white-space: pre-line; }
      `}</style>
    </LegalLayout>
  );
}
